import { Typography } from '@/shared/ui/atoms';
import * as S from './styles';

interface SectionTitleProps {
  title: {
    text: string;
    position?: string;
    color?: string;
  };
  eyebrow?: {
    text: string;
    position?: string;
    gap?: string;
    color?: string;
  };
  subtitle?: {
    text: string;
    position?: string;
    gap?: string;
    color?: string;
  };
}

const SectionTitle = ({ title, eyebrow, subtitle }: SectionTitleProps) => {
  const { text: titleText, position: titlePosition = 'text-center', color: titleColor = '#111827' } = title;
  const { text: eyebrowText, position: eyebrowPosition = 'text-center', gap: eyebrowGap, color: eyebrowColor = '#3D43FC' } = eyebrow || {};
  const { text: subtitleText, position: subtitlePosition = 'text-center', gap: subtitleGap, color: subtitleColor = '#6B7280' } = subtitle || {};
  return (
    <div>
      {eyebrow && (
        <Typography as="p" className={`${S.eyebrow} ${eyebrowGap} ${eyebrowPosition} ${eyebrowColor}`}>
          {eyebrowText}
        </Typography>
      )}
      <Typography as="h2" className={`${S.title} ${titlePosition} ${titleColor}`}>
        {titleText}
      </Typography>
      {subtitleText && (
        <Typography as="p" className={`${S.subtitle} ${subtitleGap} ${subtitlePosition} ${subtitleColor}`}>
          {subtitleText}
        </Typography>
      )}
    </div>
  );
};

export default SectionTitle;
